"use client"

import { PlaneTakeoff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PlaneTakeoffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PlaneTakeoffIcon = component(Icon)({ as: PlaneTakeoff })
